import React from 'react';

const SidebarContext = React.createContext(null);
export const SidebarProvider = SidebarContext.Provider;
export default SidebarContext;
